"use client";

import {
  type CSSVariablesResolver,
  createTheme,
  DEFAULT_THEME,
  mergeMantineTheme,
  Tooltip,
} from "@mantine/core";

const themeOverride = createTheme({
  autoContrast: true,
  primaryColor: "purple",
  colors: {
    purple: [
      "#f6eeff",
      "#e7daf7",
      "#cab1ea",
      "#ad86dd",
      "#9562d2",
      "#854bcb",
      "#7d3ec9",
      "#6b31b2",
      "#5f2aa0",
      "#52228d",
    ],
  },
  cursorType: "pointer",
  components: {
    Tooltip: Tooltip.extend({
      defaultProps: {
        events: {
          touch: true,
          hover: true,
          focus: true,
        },
      },
    }),
  },
});

export const resolver: CSSVariablesResolver = (_theme) => ({
  variables: {
    "--mantine-gradient":
      "linear-gradient(180deg, var(--mantine-color-dark-7), var(--mantine-color-dark-4))",
  },
  light: {},
  dark: {},
});

export const theme = mergeMantineTheme(DEFAULT_THEME, themeOverride);
